import { TanStackDevtools } from "@tanstack/react-devtools";
import { ReactQueryDevtoolsPanel } from "@tanstack/react-query-devtools";
import { createRootRoute, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtoolsPanel } from "@tanstack/react-router-devtools";

import { AuthProvider } from "~/components/AuthProvider";
import { QueryProvider } from "~/components/QueryProvider";
import { TooltipProvider } from "~/components/ui/Tooltip";

import "~/globals.css";

function RootLayout() {
  return (
    <AuthProvider>
      <QueryProvider>
        <TooltipProvider>
          <Outlet />
          <TanStackDevtools
            config={{
              position: "bottom-left",
            }}
            plugins={[
              {
                name: "TanStack Query",
                render: <ReactQueryDevtoolsPanel />,
              },
              {
                name: "TanStack Router",
                render: <TanStackRouterDevtoolsPanel />,
              },
            ]}
          />
        </TooltipProvider>
      </QueryProvider>
    </AuthProvider>
  );
}

export const Route = createRootRoute({ component: RootLayout });
